import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import { VisuallyHidden } from '../utils.styles';
import { playGrey15, playTransitionEasing, iconArrowRight } from '../design-tokens';
import PromotionItem from '../PromotionItem/PromotionItem';
import { playFontIcon } from '../typography/helpers';

export const GridWrapper = styled.section`
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    ${(props) =>
        props.withDivider &&
        css`
            border-top: 1px solid ${playGrey15};
            margin-top: 15px;
            padding-top: 40px;

            @media ${device.GteMedium} {
                margin-bottom: 50px;
                padding-top: 50px;
            }

            @media ${device.GteLarge} {
                margin-bottom: 60px;
                padding-top: 60px;
            }
        `}
`;

export const Heading = styled.h1`
    ${VisuallyHidden}
`;

export const BumpingArrowIcon = styled.span`
    line-height: normal;
    text-decoration: none;
    margin-left: 5px;
    vertical-align: middle;
    transition: transform 200ms ${playTransitionEasing};
    font-size: 1em;
    margin-top: -1px;

    &:before {
        ${playFontIcon(2, iconArrowRight)}
        vertical-align: baseline;
    }
`;

export const LinkToAll = styled.div`
    width: 100%;
    text-align: center;
    margin: 30px 0 0;

    @media ${device.GteSmall} {
        margin: 20px 0 0;
    }

    &:hover {
        ${BumpingArrowIcon} {
            &:before {
                transform: translateX(4px);
            }
        }
    }
`;

export const GridItem = styled(PromotionItem)`
    margin-bottom: 5px;
    margin-right: 5px;

    &:nth-of-type(2n) {
        margin-right: 0;
    }

    margin-left: 0;

    clear: both;
    width: calc((100% - 5px) / 2);

    @media ${device.GteMedium} {
        width: calc((100% - (2 * 5px)) / 3);

        &:nth-child(2n) {
            margin-right: 5px;
        }

        &:nth-child(3n) {
            margin-right: 0;
        }

        margin-left: 0;
    }

    @media ${device.GteLarge} {
        width: calc((100% - (3 * 11px)) / 4);
        margin-right: 10px;
        margin-bottom: 10px;

        &:nth-child(2n) {
            margin-right: 10px;
        }

        &:nth-child(3n) {
            margin-right: 10px;
        }

        &:nth-child(4n) {
            margin-right: 0;
        }
    }

    @media ${device.GteXLarge} {
        width: calc((100% - (4 * 11px)) / 5);

        &:nth-child(4n) {
            margin-right: 10px;
        }

        &:nth-child(5n) {
            margin-right: 0;
        }
    }

    @media ${device.FullScreen} {
        width: calc((100% - (5 * 11px)) / 6);

        &:nth-child(5n) {
            margin-right: 10px;
        }

        &:nth-child(6n) {
            margin-right: 0;
        }
    }
`;
